import { http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';
import { UserInfo } from './user-info.interface';

export class UserInfoService {
   async getUserInfo() {
      return http
         .get<UserInfo>('/user-info', {
            params: {
               include: 'teams,modules.favorites,power_bi_tokens,default_team.tenant,favorites,tenant.addons',
            },
         })
         .then((response) => response.data);
   }
   async patchUser(body: any, userId: number) {
      return http.patch<UserInfo>(`/user/${userId}`, { body }).then((response) => response.data);
   }
   async getUsers(query: LocationQuery) {
      return http.get<UserInfo>(`/user`, { params: { include: 'roles,default_team.tenant', ...query } }).then((response) => response.data);
   }
}
